// extracted by mini-css-extract-plugin
export default {"description":"EditAccessSidePanel_description__70cn1","text":"EditAccessSidePanel_text__dm3C+"};